import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { useCitation, prepareBody } from '@/utils/citationPanelUtils';
import CitationEntryUnavailable from '@/components/citation-entry-unavailable.vue';
import { useRepositories } from '@/plugins/repositories';
var buildReferencingPublicComments = function buildReferencingPublicComments(publicComments) {
  var comments = publicComments.map(function (publicComment) {
    var citations = !publicComment.contents ? null : publicComment.contents.map(function (content) {
      var sentence = prepareBody(content.content, content.linkText);
      return {
        key: content.key,
        series: content.series,
        sentence: sentence
      };
    });
    var publishedOn = new Date(publicComment.publishedOn).toLocaleDateString('ja-JP-u-ca-japanese', {
      era: 'long'
    });
    var shortTitle = "".concat(publishedOn, "\u4ED8").concat(publicComment.agency, "\u30D1\u30D6\u30B3\u30E1");
    return {
      docId: publicComment.publicCommentId,
      shortTitle: shortTitle,
      title: publicComment.publishedTitle,
      uriByAgency: publicComment.uriByAgency,
      uriOnEGov: publicComment.uriOnEGov,
      commentsAndResponsesUriExternal: publicComment.commentsAndResponsesUriExternal,
      columns: publicComment.columns || [],
      citations: citations,
      packs: publicComment.packs
    };
  });
  return comments;
};
export default defineComponent({
  name: 'CitationPanelPublicComment',
  components: {
    CitationEntryUnavailable: CitationEntryUnavailable
  },
  props: {
    documentId: {
      type: String,
      required: false,
      default: undefined
    },
    sectionKeys: {
      type: Array,
      required: false,
      default: undefined
    },
    selected: {
      type: Boolean,
      required: true
    }
  },
  setup: function setup(props) {
    var repositories = useRepositories();
    var reference = computed(function () {
      return {
        documentId: props.documentId,
        sectionKeys: props.sectionKeys
      };
    });
    var _useCitation = useCitation(reference, {
        fetcher: function () {
          var _fetcher = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(documentId, sectionKeys) {
            var docSections;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return repositories.citations.getCitationPublicComment(documentId, sectionKeys);
                case 2:
                  docSections = _context.sent;
                  return _context.abrupt("return", buildReferencingPublicComments(docSections));
                case 4:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          function fetcher(_x, _x2) {
            return _fetcher.apply(this, arguments);
          }
          return fetcher;
        }(),
        prevent: computed(function () {
          return !props.selected;
        })
        // 修正前の状態でこのコンポーネントだけローディング状態を親コンポーネントに emit していなかったのでいったんコメントアウトしておく
        // beforeFetch: () => context.emit('update:loading', true),
        // afterFetch: () => context.emit('update:loading', false),
      }),
      publicComments = _useCitation.list;
    var publicCommentLink = function publicCommentLink(_ref) {
      var uriByAgency = _ref.uriByAgency,
        uriOnEGov = _ref.uriOnEGov,
        commentsAndResponsesUriExternal = _ref.commentsAndResponsesUriExternal;
      if (uriOnEGov) {
        return uriOnEGov;
      } else if (uriByAgency) {
        return uriByAgency;
      } else {
        return commentsAndResponsesUriExternal;
      }
    };
    var cellWidthStyles = function cellWidthStyles(publicComment) {
      var _publicComment$citati;
      var res = {};
      (publicComment.columns || []).forEach(function (col, index) {
        res["--cell-width-".concat(index + 1)] = "".concat(col.weight, "%");
      });
      if (!((_publicComment$citati = publicComment.citations) !== null && _publicComment$citati !== void 0 && _publicComment$citati.length)) {
        res['--citation-height'] = '248px';
      }
      return res;
    };
    return {
      publicComments: publicComments,
      publicCommentLink: publicCommentLink,
      cellWidthStyles: cellWidthStyles
    };
  }
});